



















import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import { default as VSelect } from 'vue-select';
import { Locale } from '@/enums/Locale';

// @ts-ignore
@Component({
  components: {
    VSelect,
  },
})
export default class LanguageSelector extends Vue {
  selectedLanguage: { value: string; label: string } = this.languages.find((lg) => lg.value === 'nl-BE')!;

  get languages(): Array<{ value: string; label: string }> {
    return Object.values(Locale).map((locale) => ({ value: locale, label: this.$t(`locales.${locale}`).toString() }));
  }

  @Emit('input')
  handleLanguageChange(option: { value: string; label: string }) {
    return option.value;
  }
}
